import { makeStyles } from "@material-ui/styles";
import { getCookie } from "utils";
const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);

export const globalStyles = makeStyles({
  root: {
    padding: "24px 0",
  },
  divider: {
    margin: "16px 0 !important",
    borderTop: "1px solid #e1e1e1 !important",
  },
  flatDivider: {
    borderTop: "1px solid #e1e1e1 !important",
  },
  image: {
    width: "150px",
    height: "150px",
    objectFit: "cover",
  },
  colorGrey: {
    color: "#9AA2B1",
  },
  timer: {
    display: "flex",
    alignItems: "center",
  },
  songTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "24px",
  },
  buttonAction: {
    backgroundColor: "#111827",
    color: "white",
    width: "28px",
    height: "28px",
    padding: "6px",
    borderRadius: "6px",
    marginLeft: "8px",
    "&:hover, &.MuiIconButton": {
      background: "#374151 !important",
      color: "white",
    },
  },
  chartCard: {
    border: "1px solid #ebebeb",
    borderRadius: "5px",
    padding: "50px 20px",
  },
  filterArea: {
    backgroundColor: "#F9FAFB",
    padding: "20px 10px",
  },
  groupButton: {
    backgroundColor: "#E4E7EB",
    color: "#111827",
    textTransform: "none",
    border: "1px solid #D1D5DC",
    height: 42,
    lineHeight: "20px",
    fontSize: "0.95em",
    fontWeight: "500",
    fontFamily: "Inter",
    "&:hover": {
      backgroundColor: "#D1D5DC",
      color: "#111827",
    },
  },
  groupButtonSelected: {
    textTransform: "none",
    border: "1px solid #D1D5DC",
    color: "#111827",
    height: 42,
    lineHeight: "20px",
    fontSize: "0.95em",
    fontWeight: "500",
    fontFamily: "Inter",
    "&:hover": {
      color: "#111827",
    },
  },
  groupButtonScrollContainer: {
    display: "flex",
    overflowX: "auto",
    whiteSpace: "nowrap",
    "-webkit-overflow-scrolling": "touch",
    scrollbarWidth: "thin",
    paddingBottom: "10px",
    "&::-webkit-scrollbar": {
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
  },
  groupButtonRootContainer: {
    padding: "10px 0px",
    overflow: "hidden",
  },
  highlightText: {
    fontWeight: "bold",
  },
  totalWrapper: {
    marginTop: 10,
    backgroundColor: "#F9FAFB !important",
  },
  fieldTitle: {
    fontSize: "14px",
    fontWeight: "400 !important",
    lineHeight: "16.94px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
  },
  textDetailTransaction: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
  },
  fieldValue: {
    fontSize: "14px",
    fontWeight: "600 !important",
    lineHeight: "16.94px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
  },
  publisherProfileImage: {
    objectFit: "contain",
  },
  uploadIcon: {
    fontSize: 50,
    color: "grey",
  },
  dragFilesContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "50px",
    borderRadius: "8px",
    borderStyle: "dashed",
    transition: "0.24s ease-in-out",
    cursor: "pointer",
  },
  dragActive: {
    boxShadow: `0px 0px 8px ${userLogin?.publisher?.theme_color || "#2196f3"}`,
  },
  rightAlign: {
    display: "flex",
    justifyContent: "flex-end",
  },
  required: { color: "red" },
  bankAccountImage: {
    width: "48px",
    height: "21px",
    objectFit: "contain",
  },
  modalUploadResultIcon: {
    fontSize: 100,
    color: "#4caf50",
  },
  filePreviewContainer: {
    width: "100%",
    height: "100%",
  },
  passwordVisibiltyIcon: {
    width: "16px",
    cursor: "pointer",
  },
  loginFieldIcon: {
    width: "16px",
  },
  "&.MuiTableCell-alignRight": {
    display: "flex",
    textAlign: "right",
    flexDirection: "row-reverse",
  },
  publisherLogo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  chipIndicator: {
    height: 8,
    width: 8,
  },
  cursorPointer: {
    cursor: "pointer",
  },
  rotate90: {
    transform: "rotate(90deg)",
  },
  rotate270: {
    transform: "rotate(270deg)",
  },
  backgroundBalanceCard: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: 0,
    pointerEvents: "none",
  },
  italicText: {
    fontStyle: "italic",
  },
  bannerImage: {
    objectFit: "contain",
    width: "100%",
    borderRadius: "10px",
  },
  titleContainer: {
    margin: "20px 0",
  },
  aboutUsImageContent: {
    objectFit: "cover",
    height: 250,
    width: 350,
  },
  aboutUsImageGallery: {
    objectFit: "cover",
    height: "100%",
    width: "100%",
    display: "block",
  },
  aboutImageIntersectEllipse: {
    position: "absolute",
    zIndex: 0,
    bottom: -55,
    left: 50,
    width: 160,
  },
  aboutImageOuterEllipse: {
    position: "absolute",
    zIndex: 0,
    bottom: 55,
    left: -120,
    width: 60,
  },
  padding0: {
    padding: 0,
  },
  folderIcon: { marginRight: 8, color: "#9e9e9e" },
  fileIcon: { marginRight: 8, color: "#9e9e9e" },
  statusChipSuccess: {
    fontSize: 11,
    backgroundColor: "#4caf50",
    color: "white",
  },
  statusChipFailed: {
    fontSize: 11,
    backgroundColor: "#f44336",
    color: "white",
  },
  pathText: { fontFamily: "monospace", fontSize: 13 },
  folderClickable: {
    cursor: "pointer",
    "&:hover": { color: "#1976d2" },
  },
  chipMarginLeft: { marginLeft: 8 },
  progressLabel: { fontSize: 7, fontWeight: "bold" },
  queueChip: { height: 20, fontSize: 10, marginLeft: 8 },
  retryButton: { marginLeft: 4, padding: 2 },
  syncIcon: { fontSize: 18, color: "#424242" },
  successText: { color: "#4caf50", fontSize: 13 },
  successIcon: { color: "#4caf50", fontSize: 18 },
  failedText: { color: "#f44336", fontSize: 13 },
  failedIcon: { color: "#f44336", fontSize: 18 },
  sizeText: {
    color: "#9e9e9e",
    fontSize: 10,
    marginLeft: 8,
    whiteSpace: "nowrap",
  },
  speedText: {
    color: "#1976d2",
    fontSize: 10,
    marginTop: 4,
    whiteSpace: "nowrap",
  },
});
